import * as Sentry from '@sentry/react';

import { jsonResponseHandling } from '../fetch';
import { fetchWithAuthHeader } from '../../auth';
import HTTP_TYPES from '../../types/http-types';
import { apiUrl, CONFIG_PATH } from '../api-manager';

const { GET, PATCH } = HTTP_TYPES;

export const getUserPreferences = () => {
    const url = apiUrl(`${CONFIG_PATH}/preferences`);
    return fetchWithAuthHeader(
        url,
        {
            method: GET,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    ).then(response => jsonResponseHandling(response)).catch(error => Sentry.captureException(`Failed to get user preferences ${error})`));
};

export const updateUserPreferences = (filterObject) => {
    const url = apiUrl(`${CONFIG_PATH}/preferences`);
    return fetchWithAuthHeader(
        url,
        {
            method: PATCH,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(filterObject),
        },
    ).catch(error => Sentry.captureException(`Failed to update user preferences ${error})`));
};

export const getAlertCauses = () => {
    const url = apiUrl(`${CONFIG_PATH}/causes`);
    return fetchWithAuthHeader(
        url,
        {
            method: GET,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    ).then(response => jsonResponseHandling(response)).catch(error => Sentry.captureException(`Failed to get alert causes ${error})`));
};

export const getAlertEffects = () => {
    const url = apiUrl(`${CONFIG_PATH}/effects`);
    return fetchWithAuthHeader(
        url,
        {
            method: GET,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    ).then(response => jsonResponseHandling(response)).catch(error => Sentry.captureException(`Failed to get alert effects ${error})`));
};
